import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8688519e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8688519e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8688519e')) {
      api.createRecord('8688519e', component.options)
    } else {
      api.reload('8688519e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8688519e&scoped=true", function () {
      api.rerender('8688519e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/storeBrand/index.vue"
export default component.exports